import { useLang } from "@/context/LanguageContext";
import { LOGO } from "@/lib/assets";
import { MapPin, Mail, Facebook, Youtube, ExternalLink } from "lucide-react";

const links = ["about", "why", "programs", "professional", "admissions", "news", "gallery", "alumni", "careers", "donate", "contact"];

const socials = [
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=100063563125101", label: "Facebook" },
  { icon: Youtube, href: "https://youtube.com/@icdhhaiti9703?si=zhZQ7Oym5ZtBxcbE", label: "YouTube" },
];

const partnerLinks = [
  { label: "Triplejtaxservices.com", href: "https://triplejtaxservices.com/" },
  { label: "Lenouvelliste.com", href: "https://lenouvelliste.com/" },
];

export default function Footer() {
  const { t } = useLang();
  const go = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="relative bg-icdh-navy text-icdh-white">
      <div className="noise-overlay absolute inset-0 opacity-[0.04] pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="ICDH" className="h-12 w-12 object-contain bg-icdh-white rounded-sm p-1" />
            <div>
              <p className="font-extrabold tracking-tight text-base leading-tight">Institution Chrétienne d'Haïti</p>
              <p className="font-serif italic text-icdh-red text-sm">{t.motto}</p>
            </div>
          </div>
          <p className="mt-6 text-icdh-white/60 text-sm max-w-sm">{t.school}. {t.footer.tagline}</p>

          <div className="mt-8 flex items-center gap-3" data-testid="footer-socials">
            {socials.map(({ icon: Icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}
                className="h-10 w-10 flex items-center justify-center border border-icdh-white/25 hover:bg-icdh-red hover:border-icdh-red transition-colors">
                <Icon size={16} />
              </a>
            ))}
            <a href="https://www.tiktok.com/@icdhhaiti?_r=1&_t=ZS-98nUplGSSyT" target="_blank" rel="noreferrer" aria-label="TikTok"
              className="h-10 w-10 flex items-center justify-center border border-icdh-white/25 hover:bg-icdh-red hover:border-icdh-red transition-colors text-xs font-bold">
              Tk
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-icdh-white/50 mb-5">{t.footer.quick}</p>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l}><a href={`#${l}`} onClick={go(l)} className="text-icdh-white/80 hover:text-icdh-red transition-colors text-sm">{t.nav[l]}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-icdh-white/50 mb-5">{t.footer.contact}</p>
          <ul className="space-y-4 text-sm text-icdh-white/80">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-icdh-red mt-0.5 flex-shrink-0" />{t.contact.locations[0].address}</li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-icdh-red" />
              <a href={`mailto:${t.contact.email}`} className="hover:text-icdh-red transition-colors">{t.contact.email}</a>
            </li>
            {t.contact.email2 && (
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-icdh-red" />
                <a href={`mailto:${t.contact.email2}`} className="hover:text-icdh-red transition-colors">{t.contact.email2}</a>
              </li>
            )}
          </ul>

          <p className="mt-8 text-xs uppercase tracking-[0.28em] text-icdh-white/50 mb-4">{t.footer.partners}</p>
          <ul className="space-y-2" data-testid="footer-partners">
            {partnerLinks.map((p) => (
              <li key={p.href}>
                <a href={p.href} target="_blank" rel="noreferrer" className="text-sm text-icdh-white/70 hover:text-icdh-red transition-colors inline-flex items-center gap-1.5">
                  {p.label} <ExternalLink size={12} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="relative border-t border-icdh-white/10 py-6 text-center text-xs text-icdh-white/40">
        © {new Date().getFullYear()} {t.school}. {t.footer.rights}
      </div>
    </footer>
  );
}
